import styled from "styled-components";
import { Headline, GridContainer } from "root/libs/ui-components/src";
import { breakpoints } from "root/libs/ui-styleguide/src";
import { RadioCards } from "../RadioCards";
import {
  RadioCardLabel,
  RadioCardTitle,
  RadioCardDescription,
  RadioCardImage,
} from "../RadioCards/styled";

export const FreightHeadline = styled(Headline)`
  margin-top: var(--dui-size-space-10x) !important;
  margin-bottom: var(--gaq-size-space-30px) !important;
  @media screen and (min-width: ${breakpoints.tablet}) {
    margin-bottom: 0 0 var(--gaq-size-space-30px) 0;
  }
`;

export const FreightContentWrapper = styled.div`
  margin-left: calc(var(--dui-size-space-10x) + var(--dui-size-space-5x));
  margin-right: calc(var(--dui-size-space-10x) + var(--dui-size-space-5x));
`;

export const FreightCardWrapper = styled(GridContainer)`
  position: relative;
  border-radius: var(--dui-size-space-6x);
  transition: padding-top 0.3s ease-out;
  background-color: var(--dui-color-white-500);
  padding: 0px 0px;
  grid-template-columns: repeat(1, 1fr);
  max-width: 100rem;
  margin: var(--dui-size-space-16x) auto;

  @media screen and (min-width: ${breakpoints.desktop}) {
    grid-template-columns: 1fr;
    gap: 0px;
  }

  @media print {
    display: flex;
    flex-direction: column;
  }
`;

export const FreightContent = styled(GridContainer)`
  position: relative;
  padding: var(--dui-size-space-12x) var(--dui-size-space-20x);
  ${(props) =>
    props.stepperEnabled && `box-shadow: rgba(0, 0, 0, 0.10) 0px 5px 15px;`}
  @supports
    (display: grid) {
    @media screen and (min-width: ${breakpoints.tablet}) {
      grid-template-columns: 1fr;
      grid-column: 1 / span 12;
    }
  }
  grid-column: 1 / span 12;

  @media print {
    display: flex;
    flex-direction: column;
  }
`;

export const FreightRadioCards = styled(RadioCards)`
  grid-column: 1/-1;
  display: grid;
  gap: var(--dui-size-space-10x);
  grid-template-columns: 1fr;
  @media screen and (min-width: ${breakpoints.phablet}) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media screen and (min-width: ${breakpoints.tablet}) {
    grid-template-columns: repeat(
      ${(props) =>
        Math.min(
          props.availableColumns ?? 2,
          props.itemsCount ?? 3
        ).toString()},
      1fr
    );
  }

  @media screen and (min-width: ${breakpoints.desktop}) {
    &.side-by-side ${RadioCardLabel} {
      grid-template-areas: "image title" "image description";
      grid-template-columns: max-content 1fr;
      column-gap: var(--dui-size-space-4x);
      padding: var(--dui-size-space-9x) var(--dui-size-space-6x);

      ${RadioCardTitle} {
        text-align: start;
      }
      ${RadioCardDescription} {
        text-align: start;
        span {
          font-size: var(--dui-size-font-sm);
        }
      }
      ${RadioCardImage} {
        flex-direction: column;
      }
    }
  }
`;
export const StyledHeadline = styled(Headline)`
  margin-bottom: var(--gaq-size-space-30px) !important;

  @media screen and (min-width: ${breakpoints.tablet}) {
    margin-bottom: 0 0 var(--gaq-size-space-30px) 0;
  }
`;
